export interface Item {
  id: number;
  name: string;
  isbn?: string;
  type: ItemTypeEnum; // book : 0, merch : 1
  stockCount: number;
  price: number;
  priceType?: PriceType;
  count: number;
  image: string | undefined;
  description: string | undefined;
  isInWishList: boolean | undefined;
  primaryImage?: ImageData;
  images?: ImageData[];
  series?: SeriesData | null;
  seriesNumber?: number | null;
}

export interface SeriesData {
  id: number;
  name: string;
}

export interface ImageData {
  id: number;
  name?: string;
  url?: string;
  thumbUrl?: string;
  mediumUrl?: string;
  originalUrl?: string;
  isPrimary?: boolean;
  sortOrder?: number;
}

export enum ItemTypeEnum {
  Book = 0,
  Merch = 1
}

export interface CartItemPrice {
  amount: number;
  duration: CartItemPriceDuration;
}

export enum CartItemPriceDuration {
  Month = 0,
  TwoMonth = 1,
  ThreeMonth = 2
}

export enum PriceType {
  Sale = 0,      // 0 – продаж (Sale)
  Renatal = 1    // 1 – оренда (Renatal)
}
